import { DownloadButton } from "@monthly/ui";
import { Close, Timeline } from "@mui/icons-material";
import {
  Dialog,
  Divider,
  IconButton as MuiIconButton,
  Stack,
  Typography,
} from "@mui/material";

import type { TwoColumnLayoutV2Props } from "./TwoColumnLayoutV2";

interface FullScreenDialogProps
  extends Pick<
    TwoColumnLayoutV2Props,
    "title" | "subtitle" | "period" | "currency" | "units" | "children"
  > {
  isFullscreenIsOpen: boolean;
  handleCloseFullscreen: () => void;
  onDownload?: () => void;
}

export const FullScreenDialog = ({
  currency,
  title,
  subtitle,
  period,
  children,
  isFullscreenIsOpen,
  handleCloseFullscreen,
  units,
  onDownload,
}: FullScreenDialogProps) => {
  return (
    <Dialog
      open={isFullscreenIsOpen}
      onClose={handleCloseFullscreen}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
        },
      }}
    >
      <Stack gap={2}>
        {/* Dialog Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack spacing={1} sx={{ width: "100%", maxWidth: { sm: 540 } }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Timeline sx={{ color: "primary.light", fontSize: 24 }} />

              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                divider={
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      borderColor: "primary.dark",
                      height: 18,
                      alignSelf: "center",
                    }}
                  />
                }
              >
                <Typography variant="h5" color="primary.main">
                  {title}
                </Typography>
                <Typography
                  variant="body1"
                  color={"secondary.dark"}
                  sx={(theme) => ({
                    fontWeight: theme.typography.fontWeightSemiBold,
                  })}
                >
                  {subtitle}
                </Typography>
              </Stack>
            </Stack>

            <Typography variant="overline" color="text.primary">
              {period} {units} {currency}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            {onDownload && <DownloadButton onClickDownload={onDownload} />}
            <MuiIconButton onClick={handleCloseFullscreen} size="small">
              <Close />
            </MuiIconButton>
          </Stack>
        </Stack>

        {children.chart}
      </Stack>
    </Dialog>
  );
};
